<template>
  <b-card align="left">
    <template v-slot:header>
    </template>
    <b-row>
      <b-col lg="12" style="overflow: auto;">
      <b-table
          striped
          hover
          sticky-header
          :items="items"
          :fields="fields">
        <template v-slot:cell(Action)="row">
          <b-button size="sm" @click="openAnswer(row.item.Id)" class="mr-2">
            Ответы
          </b-button>
          <b-button size="sm" @click="openStatistics(row.item.Id)" class="mr-2">
            Статистика
          </b-button>
        </template>
      </b-table>
      </b-col>
    </b-row>
    <template v-slot:footer>
      <b-container  class="text-right">
        <small>© Customer Service 2020</small>
      </b-container>
    </template>
  </b-card>
</template>

<script>
import RestApi from '../store/RestApi'

export default {
  name: 'AdminMainPage',
  data () {
    return {
      fields: [
        { key: 'Id', label: '#', sortable: true },
        { key: 'Name', label: 'Название', sortable: false },
        { key: 'Created', label: 'Созданна', sortable: true },
        { key: 'CountAnswer', label: 'Всего анкет', sortable: true },
        { key: 'Action', label: 'Действия', sortable: false }
      ],
      items: []
    }
  },
  mounted () {
    const api = new RestApi();
    if (this.$route.params.token === api.tokenAuth) {
      this.downloadsData()
    }
  },
  methods: {
    openAnswer (id) {
      console.log(id)
      this.$router.push({path: `/admin/answers_by/${id}/${this.$route.params.token}`})
    },
    openStatistics (id) {
      console.log(id)
      this.$router.push({path: `/admin/statistics/${id}/${this.$route.params.token}`})
    },
    downloadsData () {
      RestApi.Schemas().then((responce) => {
        this.items = responce.data
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AdminMainPage.vue